import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { BrowserRouter } from 'react-router-dom';

// Load Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

console.log('🔑 Stripe Publishable Key:', process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.substring(0, 20) + '...');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Elements stripe={stripePromise}>
      
      <App />
    </Elements>
    
      </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
